export default __webpack_public_path__ + "static/road-to-thailand-img-2-1dd416377ede748347e9a6201a355193.png";